// import Blue from "~/core";
// import SwiperJS, { Navigation } from 'swiper';
// SwiperJS.use([Navigation]);
//
// new Blue({
//   name: 'Product List Carousel',
//   selector: ".productList",
//   setup(container) {
//     const random = Math.ceil(Math.random() * 10000);
//     const carousel = container.querySelector(".productList__carousel");
//     const wrapper = container.querySelector(".productList__wrapper");
//     const slides = [...container.querySelectorAll(".productList__slide")];
//     const navigationPrev = container.querySelector(".productList__prev");
//     const navigationNext = container.querySelector(".productList__next");
//
//     const setupSwiper = (isInteractive, loopSlides, centeredSlides, spaceBetween, slidesPerView) => {
//       carousel.classList.add("swiper");
//       carousel.classList.add("swiper-" + random);
//       wrapper.classList.add("swiper-wrapper");
//       slides.forEach(slide => slide.classList.add("swiper-slide"));
//
//       navigationPrev.classList.add("swiper-button-prev");
//       navigationPrev.classList.add("swiper-button-prev-" + random);
//       navigationNext.classList.add("swiper-button-next");
//       navigationNext.classList.add("swiper-button-next-" + random);
//
//       const swiper = new SwiperJS('.swiper-' + random, {
//         slidesPerView: 3,
//         // spaceBetween: 30,
//         loop: false,
//         navigation: {
//           nextEl: navigationNext,
//           prevEl: navigationPrev,
//         },
//       });
//     }
//     const initialize = () => {
//       setupSwiper();
//       // this.$addEvents(window, 'resize', resizing);
//     };
//
//     initialize();
//   }
// });

import Blue from '~/core'
import SwiperJS, { Navigation } from 'swiper'
SwiperJS.use([Navigation])

new Blue({
  name: 'Product List Carousel',
  selector: '.productList',
  setup(container) {
    const random = Math.ceil(Math.random() * 10000)
    let swiper

    const carousel = container.querySelector('.productList__carousel')
    const wrapper = container.querySelector('.productList__wrapper')
    const slides = [...container.querySelectorAll('.productList__slide')]
    const navigationPrev = container.querySelector('.productList__prev')
    const navigationNext = container.querySelector('.productList__next')

    carousel.classList.add('swiper')
    carousel.classList.add(`swiper-${random}`)
    wrapper.classList.add('swiper-wrapper')

    navigationPrev.classList.add('swiper-button-prev')
    navigationPrev.classList.add('swiper-button-prev-' + random)
    navigationNext.classList.add('swiper-button-next')
    navigationNext.classList.add('swiper-button-next-' + random)

    slides.forEach((slide) => slide.classList.add('swiper-slide'))

    const setupSwiper = (isInteractive, loopSlides, centeredSlides, spaceBetween, slidesPerView) => {
      if (swiper) swiper.destroy(true, true)
      swiper = new SwiperJS('.swiper-' + random, {
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        loop: loopSlides,
        centeredSlides: centeredSlides,
        navigation: {
          nextEl: navigationNext,
          prevEl: navigationPrev,
        },
      })
    }

    const resizing = () => {
      let slideCount = slides.length

      let isInteractive = true
      let loopSlides = false
      let centeredSlides = false
      let spaceBetween = 0
      let slidesPerView = 1

      if (slideCount >= 3) {
        if (this.$screen.lg.matches) {
          slidesPerView = 3
          if (slideCount === 3) {
            isInteractive = false
          }
        } else if (this.$screen.md.matches) {
          slidesPerView = 2
        }
      } else if (slideCount === 2 && this.$screen.md.matches) {
        isInteractive = false
        slidesPerView = 2
      } else {
        isInteractive = false
      }

      if (isInteractive) {
        container.classList.add('is-interactive')
      } else {
        container.classList.remove('is-interactive')
      }

      setupSwiper(isInteractive, loopSlides, centeredSlides, spaceBetween, slidesPerView)
    }

    const initialize = () => {
      resizing()
      this.$addEvents(window, 'resize', resizing)
    }

    initialize()
  },
})
